import React from 'react';
import { Navigate, RouteProps } from 'react-router';
import { Outlet } from 'react-router-dom';
import { Urls, useAuth } from '../../context';

const EmployeeRoute: React.FC<RouteProps> = props => {
	const auth = useAuth();

	return auth.isAuthenticated && auth.currentUser.isEmployeeUser ? <Outlet /> : <Navigate to={Urls.Documents.Root} />;
};

export default EmployeeRoute;
